"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const select_menu_style_1 = __importDefault(require("./select.menu.style"));
const status_1 = require("../../constants/status");
const veneer_1 = __importDefault(require("../../veneer/veneer"));
const constants_1 = require("../../constants");
class SelectMenu extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.buttonData = this.props.buttonElement.getBoundingClientRect();
        this.state = {
            top: this.buttonData.top < constants_1.VIEWPORT_MARGIN
                ? constants_1.VIEWPORT_MARGIN
                : this.buttonData.top,
            left: this.buttonData.left < constants_1.VIEWPORT_MARGIN
                ? constants_1.VIEWPORT_MARGIN
                : this.buttonData.left,
            right: window.innerWidth - this.buttonData.left - this.buttonData.width
        };
        this.componentDidUpdate = () => {
            if (this.props.hasValue)
                this.options.querySelector('[data-is-selected="true"]').focus();
        };
        this.componentDidMount = () => {
            window.addEventListener('resize', this.updateDimensions.bind(this));
        };
        this.componentWillUnmount = () => {
            window.removeEventListener('resize', this.updateDimensions.bind(this));
        };
        this.render = () => {
            const { classes, children, onCollapse, open, status } = this.props;
            const veneerProps = {
                handleCollapse: onCollapse,
                contentPosition: {
                    top: this.state.top,
                    left: this.state.left,
                    right: this.state.right
                },
                invisible: true,
                scrollElement: `[class="${classes.options}"]`,
                returnFocus: true
            };
            const rootProps = {
                className: classes.root,
                'data-is-open': open,
                'data-is-invalid': status === status_1.STATUS_INVALID
            };
            const optionsProps = {
                className: classes.options,
                ref: this.setOptionsRef
            };
            return (jsx_runtime_1.jsx(veneer_1.default, Object.assign({}, veneerProps, { children: jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("div", Object.assign({}, optionsProps, { children: children }), void 0) }), void 0) }), void 0));
        };
        this.setOptionsRef = this.setOptionsRef.bind(this);
    }
    setOptionsRef(el) {
        this.options = el;
    }
    updateDimensions() {
        this.buttonData = this.props.buttonElement.getBoundingClientRect();
        this.setState({
            top: this.buttonData.top < constants_1.VIEWPORT_MARGIN
                ? constants_1.VIEWPORT_MARGIN
                : this.buttonData.top,
            left: this.buttonData.left < constants_1.VIEWPORT_MARGIN
                ? constants_1.VIEWPORT_MARGIN
                : this.buttonData.left,
            right: window.innerWidth - this.buttonData.left - this.buttonData.width
        });
    }
}
exports.SelectMenu = SelectMenu;
SelectMenu.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    onCollapse: prop_types_1.default.func.isRequired,
    buttonElement: prop_types_1.default.object.isRequired,
    hasValue: prop_types_1.default.bool.isRequired,
    open: prop_types_1.default.bool.isRequired,
    status: prop_types_1.default.oneOf([status_1.STATUS_INVALID])
};
SelectMenu.defaultProps = {
    status: null
};
exports.default = react_jss_1.default(select_menu_style_1.default)(SelectMenu);
//# sourceMappingURL=select.menu.js.map